<template>
  <nav class="AppNavigation">
    <Navigation :items="links" :activeId :linkComponent="NuxtLink" />
  </nav>
</template>

<script setup lang="ts">
import { NuxtLink } from '#components';

const { links, activeId } = useNavigationLinks();
</script>

<style lang="scss">
@layer cvo-base {
  .AppNavigation {
    // The reset leaves `nav` inline, which ignores min-width
    display: block;
    min-width: 184px;
  }
}
</style>
